import { render } from "./IconMenuClose.vue?vue&type=template&id=5fe347ba"
import script from "./IconMenuClose.vue?vue&type=script&lang=js"
export * from "./IconMenuClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__